import React, { useContext } from 'react';
import Box from '../../elements/Box';
import Text from '../../elements/Text';
import Sections from './atoms/Sections';
import Articles from './atoms/Articles';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import { ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../containers/_commons/emotionCache';
import { useContainerSize } from './hooks/useContainerSize';

const TravelsGuide = (props) => {
  const {
    isMobile = false,
    data,
    titleSettings,
    containerSettings,
    sectionsSettings,
    articlesSettings,
    titleContainerSettings,
    containerComponentSettings,
    dispatch
  } = props;
  const { direction, theme, translate } = useContext(Context);

  const designTokens = theme?.designTokens ? theme?.designTokens : {};
  // const {
  //   direction,
  //   theme,
  //   translate,
  //   theme: { designTokens }
  // } = useContext(Context);

  const [className, style] = useStyles(titleSettings, { direction, theme });
  const [containerClassName, containerStyle] = useStyles(containerSettings, { direction, theme });
  const { sections, articles } = data;

  const containerRef = React.useRef(null);
  const containerWidth = useContainerSize(containerRef, 500);

  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>
        <Box
          width="100"
          style={containerStyle}
          className={`${containerClassName}`}
          focusReferences={(ref) => {
            containerRef.current = ref;
          }}
          dataTestId="travelsGuideCmp"
        >
          <Box {...titleContainerSettings} dataTestId="travelsGuideCmpTitle">
            <Text style={style} className={className} {...titleSettings}>
              {`${data.title} ${translate('cmp-travel-guide-title', 'city guide')}`}
            </Text>
          </Box>
          <Box {...containerComponentSettings}>
            <Sections
              data={sections}
              isMobile={isMobile}
              containerWidth={containerWidth}
              dispatch={dispatch}
              {...sectionsSettings}
            />
            <Articles
              data={articles}
              isMobile={isMobile}
              containerWidth={containerWidth}
              dispatch={dispatch}
              {...articlesSettings}
            />
          </Box>
        </Box>
      </ThemeProvider>
    </EmotionCache>
  );
};

export default TravelsGuide;
